import { useTranslation } from "react-i18next";
import {
  createProductTypeService,
  deleteProductTypeService,
  getAllProductTypesService,
  updateProductTypeService,
} from "../../services/Product/ProductType/ProductServices";
import { deleteProductService } from "../../services/Product/ProductServices";
import AdminNamedEntityList from "./AdminNamedEntityList";

const AdminProductTypes = () => {
  const { t } = useTranslation(["common"]);

  return (
    <AdminNamedEntityList
      title={t("common:prodType")}
      getAllService={getAllProductTypesService}
      createService={createProductTypeService}
      updateService={updateProductTypeService}
      deleteService={deleteProductTypeService}
      deleteProductService={deleteProductService}
      productMatchesEntity={(product, entityId) => product.type?._id === entityId}
    />
  );
};

export default AdminProductTypes;
